const defaultFetchConfig = () => {
  return {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json;',
    },
  };
};

export default defaultFetchConfig;
